import HTTPApiGouvFr from '@/api/HTTPApiGouvFr';

export default async function getCommune(nom, codeDepartement) {
  const queryItems = {
    params: {
      nom: nom,
      fields: 'nom,code,codesPostaux,codeDepartement',
      format: 'json',
    },
  };
  if (codeDepartement !== '') queryItems.params.codeDepartement = codeDepartement;
  const response = await HTTPApiGouvFr.get('communes', queryItems);
  return response;
}
